var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#4AAEF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8169 9.17363C15.71 9.06251 15.5646 9 15.413 9C15.2613 9 15.1159 9.06251 15.0091 9.17363L10.771 13.5526L8.99045 11.7094C8.84164 11.5574 8.62508 11.4997 8.42353 11.5584C8.22198 11.617 8.06659 11.783 8.01673 11.9929C7.96687 12.2028 8.03026 12.4241 8.18266 12.5723L10.3671 14.8264C10.4739 14.9375 10.6193 15 10.771 15C10.9227 15 11.0681 14.9375 11.1749 14.8264L15.8169 10.0365C15.9336 9.92538 16 9.76896 16 9.60507C16 9.44118 15.9336 9.28476 15.8169 9.17363Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconRound);
export default __webpack_public_path__ + "static/media/check-icon-round.4ca817b937b8d72308c34bb73db9194c.svg";
export { ForwardRef as ReactComponent };